export default __webpack_public_path__ + "static/media/mealsIcon.d21e226b.svg";